import axiosV2, { apiRequest, apiPost } from '../core/http/axios_api_v2';

export default {

    

    validateMeeting(component, meeting) {


        let meetingErrors = {};



        meetingErrors.title = !meeting.title ? 'שדה חובה' : null;
        meetingErrors.date = !meeting.date ? 'שדה חובה' : null;
        // meetingErrors.time = !meeting.time ? 'שדה חובה' : null;

        component.$set(meeting, 'errors', meetingErrors);

        //this checks if there is at least one field with an error
        let meetingIsValid = !Object.values(meetingErrors).some(value => value);

        if (!meetingIsValid)
            planup.$globals.notifyFormError();

        return meetingIsValid;
    },



    //helper functions
    ///////////////
    generateLocalEmptyMeeting(customer,date,time){
        return {
            isNotifyByMail:true,
            // notifyMailAddress:planup.$handlers.customerHandler.getCustomerEmail(customer),
            notifyMailAddress:[],
            customer,
            date,
            crewMembers: [],
            id: null,
            time,
            endTime: null,
        }
    },


    buildMeetingSummaryForTimeline(meeting){

        let meetingSummaryText = 'בתאריך ' + planup.$globals.niceDate(meeting.date);

        if (meeting.location){
            meetingSummaryText += ' ב' + meeting.location;
        }

        if (meeting.crewMembers && meeting.crewMembers.length){
            meetingSummaryText += ' עם ';
            for (let i=0; i<meeting.crewMembers.length;i++){
                meetingSummaryText += meeting.crewMembers[i].name + ', ';
            }
            meetingSummaryText = meetingSummaryText.slice(0,-2);
        }

        return meetingSummaryText;

    },




    // getting functions
    //////////////////////


    async getMeeting(meetingId){
            
            return axiosV2(`/meeting/${meetingId}`).then(
    
                response => response.data
                
            );
    },

    async getMeetings(customerId){


        if (customerId){

            return axiosV2(`/meeting/getMeetings/${customerId}`).then(

                response => response.data
                
            );
        }


        return axiosV2("/meeting/getMeetings").then(

            response => response.data
            
        );
    },


    



    //saving functions
    //////////////////

    // this function is good for general creation and initial changes,
    // saving THE WHOLE MEETING,
    // later we update specific things in the meeting no?
    async saveMeeting(meetingData,callback){

        if (!meetingData.date)
            meetingData.date = new Date();

        setNoon(meetingData.date);


        

        return apiPost('meeting',meetingData).then(
            savedMeeting => {
                
                meetingData.id = savedMeeting.id;

                if (savedMeeting.leadInProgressEventId)
                    this.leadMovedToInProgress(savedMeeting.leadInProgressEventId, meetingData.customer);
            
                planup.$handlers.calendarHandler.addItemToCache(meetingData.date,'meeting',meetingData);

                if (typeof callback == 'function')
                    callback();

                return savedMeeting.id;
            }
        );
    },


    // the meeting moved its פנייה from פניה חדשה to פניה בטיפול (the server's markLeadInProgress):
    // the open card shows it without a reload - and its next save sends the new status, not the
    // one it loaded - and the dashboard's לידים חדשים drops / patches the row
    leadMovedToInProgress(eventId, customer) {

        let event = ((customer && customer.events) || []).find(e => e && e.id == eventId);

        if (event)
            planup.$set(event, 'planupSystemStatus', 'pniaInTipul');

        planup.$handlers.eventHandler.syncDashboardLeads({ id: eventId, planupSystemStatus: 'pniaInTipul' });
    },





    // סטטוסי פגישות (התקיימה / הבריזו / בוטלה ...) ////////////////////

    // the status of a meeting (its meetingStatusId) from the store's list - a hidden one too, an old
    // meeting still shows the status it got
    statusOf(meeting) {

        let id = meeting && meeting.meetingStatusId;
        if (!id)
            return null;

        return (planup.$store.state.planupMeetingStatuses || []).find(status => status.id == id) || null;
    },

    // When the customer pressed אישור הגעה on the meeting's link (planup.co.il/r/...) - a Date, or null when
    // they did not, or did for another date / time (the meeting moved since). customerConfirmedSlot is
    // 'YYYY-MM-DD HH:MM' of the meeting's day and time (the server's meetingSlotKey)
    customerConfirmedAt(meeting) {

        if (!meeting || !meeting.customerConfirmedAt || !meeting.customerConfirmedSlot || !meeting.date)
            return null;

        let day = new Date(meeting.date);
        let time = /^(\d{1,2}):(\d{2})/.exec(meeting.time || '');
        let pad = value => (value < 10 ? '0' : '') + value;
        let slot = day.getFullYear() + '-' + pad(day.getMonth() + 1) + '-' + pad(day.getDate()) + ' ' + (time ? pad(+time[1]) + ':' + time[2] : '--:--');

        return slot == meeting.customerConfirmedSlot ? new Date(meeting.customerConfirmedAt) : null;
    },

    // "הלקוח אישר הגעה · 2/11 10:15", or '' (customerConfirmedAt above)
    customerConfirmedText(meeting) {

        let at = this.customerConfirmedAt(meeting);

        if (!at)
            return '';

        let pad = value => (value < 10 ? '0' : '') + value;

        return 'הלקוח אישר הגעה · ' + at.getDate() + '/' + (at.getMonth() + 1) + ' ' + pad(at.getHours()) + ':' + pad(at.getMinutes());
    },

    // the statuses a meeting can get now: the list without the hidden ones, in the order they were made
    statusOptions() {
        return (planup.$store.state.planupMeetingStatuses || []).filter(status => !status.hidden);
    },

    statusColor(status) {
        return (status && /^#[0-9a-f]{6}$/i.test(status.color || '')) ? status.color : '#8d63da';
    },

    // null takes the status off
    setMeetingStatus(meetingId, meetingStatusId) {
        return apiPost(`meeting/${meetingId}/status`, { meetingStatusId: meetingStatusId || null });
    },

    // the customer's meetings that wait for a new date - a new meeting can be set in place of one
    getRescheduleCandidates(customerId) {
        return apiRequest('get', `meeting/reschedule-candidates?customerId=${customerId}`, null, {}, true);
    },

    // who set the meeting: "נקבעה על ידי מעין מלכה · 2/11/2026 09:16", or for an online booking "נקבעה בזימון
    // אונליין, אושרה על ידי ..." (the api's createdByName + bookedOnline - meeting-created-by.ts); '' when it is
    // not known (a meeting made before 2/11/2026)
    createdByText(meeting) {

        if (!meeting || !meeting.id || (!meeting.createdByName && !meeting.bookedOnline))
            return '';

        let pad = value => (value < 10 ? '0' : '') + value;
        //the db's wall clock handed out with a Z - read as local time (TaskBoard.wallClockDate, $globals.niceDate)
        let at = meeting.created ? new Date(typeof meeting.created === 'string' ? meeting.created.replace(/Z$/, '') : meeting.created) : null;
        let when = at && !isNaN(at.getTime())
            ? ' · ' + at.getDate() + '/' + (at.getMonth() + 1) + '/' + at.getFullYear() + ' ' + pad(at.getHours()) + ':' + pad(at.getMinutes())
            : '';

        if (meeting.bookedOnline)
            return 'נקבעה בזימון אונליין' + (meeting.createdByName ? ', אושרה על ידי ' + meeting.createdByName : '') + when;

        return 'נקבעה על ידי ' + meeting.createdByName + when;
    },

    // a new meeting in place of one that waits for a new date: the same customer, kind, title, place
    // and crew, and no date yet - the form asks for one
    generateRescheduleMeeting(oldMeeting, customer) {

        let meeting = this.generateLocalEmptyMeeting(customer || oldMeeting.customer, null, null);

        meeting.title = oldMeeting.title || '';
        meeting.meetingType = oldMeeting.meetingType || null;
        meeting.place = oldMeeting.place || null;
        meeting.crewMembers = deepCopy(oldMeeting.crewMembers || []);
        meeting.comments = oldMeeting.comments || '';
        //the api puts the new meeting on the old one's event
        meeting.rescheduleOfId = oldMeeting.id;

        return meeting;
    },




    //navigation functions
    gotoAddNewMeeting(customer,date){
        if (date){
            planup.$router.push(`/customer/${customer.id}?newMeeting=${date.getTime()}`)
        } else {
            planup.$router.push(`/customer/${customer.id}?newMeeting`)
        }
        
    },

    deleteMeeting(meetingId){
        return apiPost(`meeting/delete/${meetingId}`).then(


            
            response => {

                response.data
            }
            
        )
    },

    gotoAddNewMeetingFromSearch(searchResult,date,time){
        
        if (date){
            
            let url = `/customer/${searchResult.customerId}?newMeeting=${date.getTime()}`;

            if (time)
                url += '&timeForMeeting=' + time;

            planup.$router.push(url)
        } else {
            planup.$router.push(`/customer/${searchResult.customerId}?newMeeting`)
        }
        
    },


    calendarTooltip(eventId) {
        return axiosV2.get(`/meeting/tooltip/${eventId}`).then(response => {

            let html = `
            
                <div style="text-align: center;color:rgb(119, 119, 119)">
                    ${planup.$globals.niceDate(response.data.date)}

                    ${response.data.time ? ' &nbsp; ' + response.data.time : '' }

                </div>
                <br>

                <div style="font-weight:bold;">

                    ${response.data.title}

                </div>

                <br>
            
            `;






            for (let i = 0; i < response.data?.customer?.contacts?.length; i++) {

                html += `<img class='eventTooltipContactImage' src="${planup.$handlers.customerHandler.getContactImage(response.data.customer.contacts[i])}"> ${response.data.customer.contacts[i].firstName}&nbsp;&nbsp;`

            }

            html += '<br>';
            html += '<br>';


            if (response.data?.meetingType?.name)
                html += 'סוג פגישה: ' + response.data.meetingType.name + '<br>'


            if (response.data?.place?.name)
                html += 'מקום: ' + response.data.place.name + '<br>'


            if (response.data?.crewMembers && response.data.crewMembers.length)
                html += 'צוות : ' + response.data.crewMembers.map(member => member.name).join(', ') + '<br>'


            return html;

        })
    },



}